import { Injectable } from '@angular/core';
import { LogTypeEnum } from '../enums/log-enum';
import { LogEntry } from '../models/log-entry';
import { Logger } from '../models/logger';
import { LoggersService } from './loggers.service';

@Injectable({ providedIn: 'root' })
export class LogService {
  private loggers: Logger[];
  level: LogTypeEnum = LogTypeEnum.ALL;
  logWithDate: boolean = true;

  constructor(
    loggersSvc: LoggersService
  ) {
    this.loggers = loggersSvc.loggers
  }

  all(msg: string, params?: any) { this.writeLog(msg, LogTypeEnum.ALL, params) }
  debug(msg: string, params?: any) { this.writeLog(msg, LogTypeEnum.DEBUG, params) }
  info(msg: string, params?: any) { this.writeLog(msg, LogTypeEnum.INFO, params) }
  warn(msg: string, params?: any) { this.writeLog(msg, LogTypeEnum.WARN, params) }
  error(msg: string, params?: any) { this.writeLog(msg, LogTypeEnum.ERROR, params) }
  fatal(msg: string, params?: any) { this.writeLog(msg, LogTypeEnum.FATAL, params) }

  clear(): void {
    for (const logger of this.loggers) {
      logger.clear().subscribe((msg) => {})
    }
  }
  private writeLog(msg: string, level: LogTypeEnum, data?: any) {
    if (this.shouldLog(level)) {
      let logEntry = new LogEntry();
      logEntry.message = msg;
      logEntry.level = level;
      logEntry.data = data;
      logEntry.logWithDate = this.logWithDate;

      for (const logger of this.loggers) {
        logger.log(logEntry).subscribe(response => { })
      }
    }
  }

  shouldLog(level: LogTypeEnum) {
    let ret: boolean = false;

    if (
      (level >= this.level && level != LogTypeEnum.OFF) ||
      this.level == LogTypeEnum.ALL
    ) {
      ret = true;
    }
    return ret;
  }




}
